

export default {
  name: "DadataInput",

  props: {
    value: {
      type: String,
      default: "",
    },
    inputClass: {
      type: [String, Array, Object],
      default: "",
    },
    placeholder: {
      type: String,
      default: "ООО Компания",
    },
  },

  data: function () {
    return {
      suggestions: [],
      showList: false,
      debounceId: null,
      blurTimer: null,
      lastPickedOrganization: "",
    };
  },

  watch: {
    value: function (val) {
      if (!val) {
        this.lastPickedOrganization = "";
        this.suggestions = [];
        this.showList = false;
      }
    },
  },

  beforeDestroy: function () {
    if (this.debounceId) {
      clearTimeout(this.debounceId);
    }
    if (this.blurTimer) {
      clearTimeout(this.blurTimer);
    }
  },

  methods: {
    onInput: function (e) {
      const next = e.target.value;
      // т.к снаружи стоит связка v-model=form.organization, то в организацию уходит содержимое от ввода в инпут, там обновляется
      // здесь обновляется прпос value, а он обновляет внутренний инпут (сквозное связывание)
      this.$emit("input", next);
      if (next.trim() !== (this.lastPickedOrganization || "").trim()) {
        this.$emit("organization-meta", { inn: "" });
      }
      this.scheduleFetch();
    },

    onFocus: function () {
      if (this.suggestions.length) {
        this.showList = true;
      }
    },

    onBlur: function () {
      if (this.blurTimer) {
        clearTimeout(this.blurTimer);
      }
      this.blurTimer = setTimeout(() => {
        this.showList = false;
        this.blurTimer = null;
      }, 200);
    },

    scheduleFetch: function () {
      if (this.debounceId) {
        clearTimeout(this.debounceId);
      }
      this.debounceId = setTimeout(() => {
        this.debounceId = null;
        this.fetchSuggestions();
      }, 300);
    },

    onPick: function (suggestion) {
      const name = (suggestion.value || suggestion.unrestricted_value || "").trim();
      this.lastPickedOrganization = name;
      this.$emit("input", name); // т.к снаружи стоит связка v-model=form.organization, то в организацию уходит name
      this.$emit("organization-meta", {
        inn: (suggestion.data && suggestion.data.inn) || "",
      });
      this.suggestions = [];
      this.showList = false;
    },

    fetchSuggestions: async function () {
      const localQuery = (this.value || "").trim();

      if (localQuery.length < 3) {
        this.suggestions = [];
        this.showList = false;
        return;
      }

      const body = {
        url: "https://suggestions.dadata.ru/suggestions/api/4_1/rs/suggest/party",
        data: {
          query: localQuery,
        },
      };

      try {
        const response = await this.$api.agent.transport.post('dadata/send', body);

        if (response.statusText !== 'OK') {
          this.suggestions = [];
          this.showList = false;
          return;
        }
        this.suggestions = Array.isArray(response.data.suggestions) ? response.data.suggestions : [];
        this.showList = this.suggestions.length > 0;
      } catch (e) {
        this.suggestions = [];
        this.showList = false;
      }
    },
  },
};
